import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import { createLogger } from 'redux-logger';
import { REACT_APP_REDUX_DEBUGGING_ENABLED } from 'dotenv';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['tprinfo', 'uploadTreatmentPlanMetadata', 'uploadTreatmentPlan', 'surgicalCasesAttachments', 'surgicalPlanErrorCodes', 'relatedCase', 'patientScans', 'TPRHistory', 'listTreatmentPlanRequest', 'getTreatmentPlanFilter', 'getSurgeonPreferences', 'getSurgeons', 'getHospitals', 'getBranches', 'getAllTreatmentPlans', 'deleteSurgeonPreferences', 'formChangeLog']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default initialState => {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
      const middleware = getDefaultMiddleware({ serializableCheck: false });
      if (REACT_APP_REDUX_DEBUGGING_ENABLED === 'true') {
        middleware.push(createLogger());
      }
      return middleware;
    },
    preloadedState: initialState,
  });
  const persistor = persistStore(store);
  return { store, persistor };
};




